export default {"src":"/_next/static/media/gray-dimensional-chain.943d075d.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};